const expression = /(https?:\/\/)?[\w\-~]+(\.[\w\-~]+)+(\/[\w\-~@:%]*)*(#[\w-]*)?(\?[^\s]*)?/gi;
const topDomains = [
  /\.com/,
  /\.de/,
  /\.org/,
  /\.net/,
  /\.us/,
  /\.co/,
  /\.edu/,
  /\.gov/,
  /\.biz/,
  /\.za/,
  /\.info/,
  /\.cc/,
  /\.ca/,
  /\.cn/,
  /\.fr/,
  /\.ch/,
  /\.au/,
  /\.in/,
  /\.jp/,
  /\.be/,
  /\.it/,
  /\.nl/,
  /\.uk/,
  /\.mx/,
  /\.no/,
  /\.ru/,
  /\.br/,
  /\.se/,
  /\.es/,
  /\.at/,
  /\.dk/,
  /\.eu/,
  /\.il/,
];

const splitText = (textToCheck) => {
  const regex = new RegExp(expression);
  let match = '';
  const texts = [];
  let startIndex = 0;
  let domainMatch = '';
  let urlLength = 0;
  let abort = false;

  // this algorithm does the checking AND pushes text or link into an array
  // eslint-disable-next-line no-cond-assign
  while ((match = regex.exec(textToCheck)) != null) {
    abort = true;

    // We need to double check if this is one of the "known" topDomains like .com
    for (let i = 0; i < topDomains.length; i += 1) {
      domainMatch = match[0].match(topDomains[i]);
      if (domainMatch) {
        urlLength = domainMatch[0].length + domainMatch.index;
        // We found one of the domains we look for - now we need to
        // know if the .com or .de etc. is at the VERY END  of the domain
        if (match[0].length === urlLength) {
          abort = false;
        }
        if (match[0].length > urlLength) {
          if (match[0].substr(urlLength, 1) === '/') {
            abort = false;
          }
        }
      }
    }
    // we want to avoid matching email addresses
    if (match.index !== 0 && textToCheck[match.index - 1] === '@') {
      abort = true;
    }
    // we want to avoid matching ? without anything at the end like www.epiloge.com/@axel-wittmann?
    if (match.index !== 0 && textToCheck[match.index + match[0].length - 1] === '?') {
      match[0] = match[0].substr(0, match[0].length - 1);
    }

    // we always put in the last text
    texts.push({
      text: textToCheck.substr(startIndex, match.index - startIndex),
      type: 'text',
    });

    // however, based on the match, we either create a link, or no link, just text
    if (abort) {
      texts.push({ text: textToCheck.substr(match.index, match[0].length), type: 'text' });
    } else {
      let cleanedLink = textToCheck.substr(match.index, match[0].length);
      cleanedLink = cleanedLink.replace(/^https?:\/\//, '');
      texts.push({ text: cleanedLink, type: 'link' });
    }
    startIndex = match.index + match[0].length;
  }

  if (startIndex < textToCheck.length) {
    texts.push({ text: textToCheck.substr(startIndex), type: 'text' });
  }

  return texts;
};

export const getUrls = (textToCheck) => {
  const texts = splitText(textToCheck);
  return texts.reduce((all, next) => {
    if (next.type === 'link') {
      let text = next.text;
      if (text.indexOf('http://') !== 0 && text.indexOf('https://') !== 0) {
        text = `https://${text}`;
      }
      all.push(text);
    }

    return all;
  }, []);
};

export default splitText;
